import { defineMessages } from "react-intl";
import type { PlaylistableResources } from "./EditPlaylist/usePlaylistableResources";

export const ROUTES = {
  create: "create",
  edit: "edit",
  play: "play",
  editAssignment: "edit-recipients",
};

export const CURRENT_RESOURCE_PARTS = [
  "resourceType",
  "resourceId1",
  "resourceId2",
  "resourceId3",
  "resourceId4",
] as const;
export const CURRENT_RESOURCE_PARAMS = CURRENT_RESOURCE_PARTS.map(
  (part) => `:${part}?`,
).join("/");
export type CreateURLParams = {
  resourceType?: PlaylistableResources;
  resourceId1?: string;
  resourceId2?: string;
  resourceId3?: string;
  resourceId4?: string;
};

export const TITLE_MAX_LEN = 50;
export const DESCRIPTION_MAX_LEN = 330;

export const PLAYLIST_MESSAGE = defineMessages({
  changeButton: {
    id: "playlist-changeButton",
    defaultMessage: "change",
  },
  share: {
    id: "playlist-share",
    defaultMessage: "Share",
  },
  playlistUse: {
    id: "playlist-use",
    defaultMessage: "Use",
  },
  noRecipients: {
    id: "playlist-no-recipients",
    defaultMessage: "This playlist has not recipients yet.",
  },
  playlistDuplicate: {
    id: "playlist-duplicate",
    defaultMessage: "Duplicate.",
  },
  playlistIsDuplicate: {
    id: "playlist-is-duplicate",
    defaultMessage: "Duplicate of",
  },
  playlistIsAssignment: {
    id: "playlist-is-assignement",
    defaultMessage: "Sharing of",
  },
  playlistArchive: {
    id: "playlist-archive-button",
    defaultMessage: "Archive",
  },
  createdOn: {
    id: "playlist-created-on",
    defaultMessage: "Created on",
  },
  averageProgression: {
    id: "playlist-average-progression",
    defaultMessage: "playlist average progression",
  },
  showDetail: {
    id: "playlist-resource-card-button-label",
    defaultMessage: "Show more about {playlistName}",
  },
  editPlaylist: {
    id: "playlist-editPlaylist",
    defaultMessage: "Edit",
  },
  viewPlaylist: {
    id: "playlist-viewPlaylist",
    defaultMessage: "View",
  },
  draft: {
    id: "playlist-draftChip",
    defaultMessage: "Draft",
  },
  readonly: {
    id: "playlist-readonlyChip",
    defaultMessage: "Template",
  },
  progress: {
    id: "playlist-progress",
    defaultMessage: "Progress",
  },
});
